module.exports = "/images/vendor/flag-icon-css/flags/4x3/cn.svg?02c229de4d98ea1668384d2ed4cc558d";